import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useNotificationContext } from '@/modules/notifications/NotificationContext/hooks/useNotificationContext';

const NOTIFICATION_APP_ID_QUERY_PARAM = 'notificationAppId';

/** Acknowledge an email link once per notification without blocking navigation. */
export function useAcknowledgeEmailNotification() {
  const { markRead } = useNotificationContext();
  const [searchParams] = useSearchParams();
  const notificationAppId = searchParams.get(NOTIFICATION_APP_ID_QUERY_PARAM);
  const markedNotificationIds = useRef(new Set<string>());

  useEffect(() => {
    if (
      !notificationAppId ||
      markedNotificationIds.current.has(notificationAppId)
    ) {
      return;
    }

    markedNotificationIds.current.add(notificationAppId);
    // Email acknowledgment is optional: the app notification may no longer exist.
    void markRead(notificationAppId, { reportErrors: false }).catch(
      () => undefined
    );
  }, [markRead, notificationAppId]);
}
